export interface RegistryLinkData {
  link: string;
  linkText: string;
}

interface RegistryData {
  text: string;
  links: RegistryLinkData[];
}

export const registry: RegistryData = {
  text:
    'Just having you all here for our wedding is gift enough! However, if you feel like getting us something, \
    we would love for you to contribute to our honeymoon with a fun adventure or a meal out. \
    If you would like to go the more traditional route, we’ve added a few things to our West Elm registry as well.',
  links: [
    {
      link: 'https://www.travelersjoy.com/mattandbriana',
      linkText: "Honeymoon registry at Traveler's Joy",
    },
    {
      link: 'https://www.westelm.com/registry/qc7cgtdjz9/registry-list.html',
      linkText: 'West Elm registry',
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/registry.ts